import { z } from 'zod';
import { syncAction } from '@/lib/action';
import { notificationEvent } from '@/domain/ws/global/envelope';

export const PermissionsChangedSchema = notificationEvent(
  'PERMISSIONS_CHANGED',
  z.object({
    company_id: z.string().nullable(),
  }),
);

type PermissionsChanged = z.infer<typeof PermissionsChangedSchema>;

export const permissionsChangedAction = syncAction<{ companyId: PermissionsChanged['metadata']['company_id'] }>(
  'WS/GLOBAL/PERMISSIONS_CHANGED',
);

export const toPermissionsChangedAction = (event: PermissionsChanged) =>
  permissionsChangedAction({ companyId: event.metadata.company_id });
